import React, { useContext, useEffect } from "react";
import navbarLogo from "../img/navbar-logo-original.svg";
import Heart from "../img/heart-02.svg";
import Compare1 from "../img/compare-01.svg";
// import Compare2 from "../img/compare-02.svg";
import { Moments } from "../context/MomentsContextProvider";

const Navbar = (props) => {
    const momentsContext = useContext(Moments);

    // const [isMonthView, setIsMonthView] = useState(true);
    const toggleMonthYear = () => {
        // TODO: make timeline / gallery respond to mode change
        // setIsMonthView(!isMonthView);
        momentsContext.setIsMonthView(!momentsContext.isMonthView);
        props.setIsMonthView(!momentsContext.isMonthView);
    };

    useEffect(() => {
        momentsContext.setIsMonthView(props.isMonthView);
    }, [props.isMonthView]);

    const compare = () => {
        // deactivate like / year view
        if (!momentsContext.isMonthView) {
            momentsContext.setIsMonthView(!momentsContext.isMonthView);
        }
        if (momentsContext.isLikeView) {
            momentsContext.setIsLikeView(!momentsContext.isLikeView);
        }
        momentsContext.setIsCompareView(!momentsContext.isCompareView);
        props.setIsCompareView(!momentsContext.isCompareView);
    };

    const viewFavourites = () => {
        // todo
        console.log("View Favourites");
        momentsContext.setIsLikeView(!momentsContext.isLikeView);
    };

    return (
        <nav className="navigation-container">
            <div className="navigation-logo">
                <img src={navbarLogo} alt="Nap time" />
            </div>

            <div className={momentsContext.isCompareView ? "navigation-title hidden-nav-item" : "navigation-title"}>
                <h1>The Tan family timeline</h1>
            </div>

            <ul className={momentsContext.isCompareView ? "navigation-links isCompare" : "navigation-links"}>
                <li className={momentsContext.isCompareView ? "hidden-nav-item" : ""}>
                    <button onClick={toggleMonthYear} className={`year-month-toggle ${momentsContext.isMonthView ? "toggled" : ""}`}>
                        <div className="toggle-years">Years</div>
                        <div className="toggle-months">Months</div>
                    </button>
                </li>
                <li className={momentsContext.isCompareView ? "hidden-nav-item" : ""}>
                    <button className="navigation-links__favourites button button--winona button--border-thick button--round-l button--text-upper button--size-s button--text-thick" data-text="View favourites" onClick={viewFavourites}>
                        <img src={Heart} alt="heart"></img>
                        <span className="span-hover">View favourites</span>
                        <span className="counter">{momentsContext.likedMoments.length + ""}</span>
                    </button>
                </li>
                <li>
                    <button className={`${momentsContext.isCompareView ? "is-active" : ""} navigation-links__compare button button--winona button--border-thick button--round-l button--text-upper button--size-s button--text-thick}`} data-text="Compare" onClick={compare}>
                        <img src={Compare1} alt="compare"></img>
                        <span className="span-hover">Compare</span>
                    </button>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;
